export type DeltaDirection = "up" | "down" | "flat";

/**
 * Плитка метрики DS (canon-session 2026-07-24). Число ВСЕГДА ink-1
 * (text-primary) — семантика только в delta-строке под числом
 * (canon раздел 1.4, как StatTile). up=ok / down=bad / flat=muted.
 */
export function MetricCard({
  label,
  value,
  unit,
  delta,
  deltaDirection = "flat",
}: {
  label: string;
  /**
   * `null`/`undefined` — «данных ещё нет», рисуется прочерком. Соседний
   * `StatTile` умеет это с самого начала, а здесь тип не давал вызывающему
   * сказать «не знаю», и на загрузке в плитку уходил вычисленный ноль.
   */
  value: string | number | null | undefined;
  unit?: string;
  delta?: string;
  deltaDirection?: DeltaDirection;
}) {
  const deltaCls =
    deltaDirection === "up"
      ? "text-ok"
      : deltaDirection === "down"
        ? "text-bad"
        : "text-fg-muted";
  const arrow =
    deltaDirection === "up" ? "↑" : deltaDirection === "down" ? "↓" : "";

  return (
    <div className="bg-bg-card border border-border rounded-xl px-3 pt-3 pb-[11px]">
      <span className="font-mono text-[10px] tracking-[0.1em] uppercase text-text-tertiary">
        {label}
      </span>
      <b className="block mt-[7px] text-[21px] font-semibold text-text-primary tabular-nums">
        {value ?? "—"}
        {unit && (
          <i className="not-italic text-[11px] font-normal text-text-tertiary ml-0.5">
            {" "}
            {unit}
          </i>
        )}
      </b>
      {delta && (
        <span className={`block font-mono text-[10.5px] mt-1 ${deltaCls}`}>
          {arrow} {delta}
        </span>
      )}
    </div>
  );
}
